/** `/about`: За сайта. The text is in src/app/content/about.tsx. */

import { ContentPage } from '../components/ContentPage.tsx'
import { AboutBg, AboutEn } from '../content/about.tsx'

export function About() {
  return <ContentPage titleKey="about.title" page="about" bg={<AboutBg />} en={<AboutEn />} />
}
